import React from 'react';
import { FaCamera, FaCheckCircle, FaTag } from 'react-icons/fa';

const STEPS = [
  { id: 1, label: 'Photos', short: 'Click 1', icon: FaCamera },
  { id: 2, label: 'Part details', short: 'Click 2', icon: FaCheckCircle },
  { id: 3, label: 'Pricing', short: 'Click 3', icon: FaTag },
];

export default function ShelfListingStepper({ current = 1 }) {
  return (
    <nav aria-label="Listing progress" className="mb-6">
      <ol className="flex items-center justify-between gap-1 max-w-md mx-auto">
        {STEPS.map((step, idx) => {
          const Icon = step.icon;
          const done = step.id < current;
          const active = step.id === current;
          return (
            <li key={step.id} className="flex flex-1 items-center">
              <div className="flex flex-col items-center flex-1 min-w-0">
                <span
                  className={`flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold transition-colors ${
                    done
                      ? 'bg-emerald-600 text-white'
                      : active
                        ? 'bg-emerald-100 text-emerald-800 ring-2 ring-emerald-600'
                        : 'bg-slate-100 text-slate-400'
                  }`}
                >
                  {done ? <FaCheckCircle className="text-sm" /> : <Icon className="text-sm" />}
                </span>
                <span
                  className={`mt-1.5 text-[10px] font-semibold uppercase tracking-wide truncate w-full text-center ${
                    active ? 'text-emerald-700' : done ? 'text-slate-600' : 'text-slate-400'
                  }`}
                >
                  {step.short}
                </span>
                <span className="text-[10px] text-slate-500 truncate w-full text-center hidden sm:block">
                  {step.label}
                </span>
              </div>
              {idx < STEPS.length - 1 && (
                <div
                  className={`h-0.5 flex-1 mx-1 mb-5 rounded ${
                    step.id < current ? 'bg-emerald-500' : 'bg-slate-200'
                  }`}
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
